import React from 'react';
import CellFactory from '../../CellFactory';

const EdexcelIGCSE = ({ row }) => {
  const { year, paper1, paper1Ms, paper1PredictedList, paper2, paper2Ms, paper2PredictedList } =
    row;
  return (
    <tr>
      <td>{year}</td>
      <td>
        <CellFactory cells={paper1} />
      </td>
      <td>
        <CellFactory cells={paper1Ms} />
      </td>
      <td>
        <CellFactory cells={paper1PredictedList} />
      </td>
      <td>
        <CellFactory cells={paper2} />
      </td>
      <td>
        <CellFactory cells={paper2Ms} />
      </td>
      <td>
        <CellFactory cells={paper2PredictedList} />
      </td>
    </tr>
  );
};

export default EdexcelIGCSE;
